import './style.css'
import {onClickNotif} from 'actions/notifications'

class NotificationBar extends React.Component {
  render () {
    const {bars, notificationClicked} = this.props.notification
    let {pathname} = this.props.location
    let doms = bars.map(function (bar, index) {
      return (!notificationClicked &&
        <div key={index} className={(pathname === '/reports/invoices') || (pathname === '/reports/transactions')
          ? `mk-alert-box-trx-inv trans-1 ${bar.level}`
          : `mk-alert-box trans-1 ${bar.level}`}>
          <div className='container'>
            <div className={bar.message.length > 37 ? 'mk-alert pad2' : 'mk-alert pad11'}>
              <div>{bar.message}</div>
            </div>
          </div>
        </div>
      )
    })

    return (<div onClick={() => { this.props.dispatch(onClickNotif(true)) }}>{doms}</div>)
  }
}

NotificationBar.propTypes = {
  notification: React.PropTypes.object,
  dispatch: React.PropTypes.func,
  location: React.PropTypes.object
}
export default NotificationBar



// WEBPACK FOOTER //
// ./app/components/Notification/NotificationBar.js